import {toggleDarkModeBody, isDarkModeActive, disableDarkModeIfNotClosest} from "../utilities/domGeneralManipulation";
import {getSearchStatus, disableSearch} from './searchBar';

let isNavActive = false;

export const getNavStatus = () => isNavActive;

export const disableAllMegaMenu = (expect = null) => {
    const allMegaMenu = document.querySelectorAll('.nav-item--active');

    allMegaMenu.forEach(megaMenu => {
        if(megaMenu === expect) {
            return;
        }
        megaMenu.classList.remove('nav-item--active');
    })

    isNavActive = false;
}

export default () => {
    const domElements = {
        nav: document.querySelector('.nav'),
    }

    const toggleNavigationStatus = (e) => {
        const {target} = e;

        if (!target.matches('.nav-button') && !target.closest('.nav-button')) {
            return;
        }

        const darkModeStatus = isDarkModeActive();
        const navItem = target.closest('.menu-item-has-children');

        disableAllMegaMenu(navItem);
        const classStatus = navItem.classList.toggle('nav-item--active');

        if(getSearchStatus()) {
            disableSearch();
        }

        if(!darkModeStatus) {
            toggleDarkModeBody();
            isNavActive = !isNavActive;
            return;
        }

        if (!classStatus || !isNavActive) {
            if (!classStatus) {
                toggleDarkModeBody();
            }
            isNavActive = !isNavActive;
            return;
        }
    }

    const megaMenuImageReplacing = (e) => {
        const {target} = e;
        const item = target.classList.contains('nav-mega-item') ? target : target.closest('.nav-mega-item');

        if(!item || !item.classList.contains('nav-mega-item')) {
            return;
        }

        const menuId = item.dataset?.itemid;
        
        if(!menuId) {
            return;
        }

        const menuImage = document.querySelector(`.nav-mega-images__single[data-id="${menuId}"]`);
 
        if(!menuImage) {
            return;
        }

        const itemContainer = item.closest('.nav-item-mega');

        itemContainer.querySelector('.nav-mega-images__single--active').classList.remove('nav-mega-images__single--active');
        menuImage.classList.add('nav-mega-images__single--active');
    }
    
    const imageToDefault = (e) => {
        const {target} = e;

        if(target.classList.contains('nav-mega-item') ) {
            return;
        }

        const wrapper = target.closest('.nav-mega');

        if(!wrapper) {
            return;
        }

        const menuId = wrapper.dataset?.itemid;

        if(!menuId) {
            return;
        }

        const itemToActive = wrapper.querySelector(`.nav-mega-images__single[data-id="${menuId}"]`);
        const currentActive = wrapper.querySelector('.nav-mega-images__single--active');

        if(itemToActive === currentActive) {
            return;
        }

        itemToActive.classList.add('nav-mega-images__single--active');
        currentActive.classList.remove('nav-mega-images__single--active');
    }


    document.body.addEventListener('click', toggleNavigationStatus);

    domElements.nav.addEventListener('mouseover', megaMenuImageReplacing);
    domElements.nav.addEventListener('mouseout', imageToDefault);
}
